import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/contexts/AuthContext';
import PageLoader from '@/routes/page-loader';
import { paths } from '@/shared/routes/paths';

/**
 * Wrapper that redirects unauthenticated users to /login.
 * Preserves the intended destination in ?redirect= so the user
 * is sent back after login.
 */
export default function AuthGuard() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Wait for session check to complete before redirecting. Show the same
  // spinner as the Suspense fallback so the first paint isn't a blank screen.
  if (isLoading) return <PageLoader />;

  if (!isAuthenticated) {
    const intended = location.pathname + location.search;
    const loginUrl = intended && intended !== '/'
      ? `${paths.login}?redirect=${encodeURIComponent(intended)}`
      : paths.login;
    return <Navigate to={loginUrl} replace />;
  }

  return <Outlet />;
}
